import { render, staticRenderFns } from "./Video.Dialog.vue?vue&type=template&id=017972f2&scoped=true&"
import script from "./Video.Dialog.vue?vue&type=script&lang=js&"
export * from "./Video.Dialog.vue?vue&type=script&lang=js&"
import style0 from "./Video.Dialog.vue?vue&type=style&index=0&id=017972f2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017972f2",
  null
  
)

export default component.exports